<template>
  <div class="o-player">
    <Viewer class="o-player__viewer"></Viewer>
    <Timeline class="o-player__timeline"
              v-bind:class="{ '--play': isPlaying && active, classMouse }"
              v-on:scrollNext="scrollNext()"
              v-on:scrollPrevious="scrollPrevious()"></Timeline>
    <Slugs class="o-player__slugs"
           v-bind:class="{ '--play': isPlaying && active, classMouse }"></Slugs>
    <Details class="o-player__details"></Details>
    <img class="o-player__logo" src="../assets/images/logo.png" alt="" v-on:click="goSlug()">
    <Loading class="o-player__loading"
             :class="{ classMouse }"
             v-bind:message="displayedLoading"></Loading>
    <div class="o-player__mouse" v-bind:style="positionMouse" v-bind:class="classMouse">
      <span class="more">Lire l'actu</span>
      <span class="close">Fermer</span>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import { TimelineLite } from 'gsap';

import Timeline from './Player/Timeline';
import Viewer from './Player/Viewer';
import Channels from './Player/Channels';
import Details from './Player/Details';
import Slugs from './Player/Slugs';
import Loading from './Player/Loading';
import srcImgClose from '../assets/images/cross.png';
import srcImgMore from '../assets/images/more.png';

const OFFSET = 3;

export default {
  name: 'player',
  data() {
    return {
      active: false,
      changer: new TimelineLite(),
      displayedLoading: 'Chargement',
      positionMouse: {
        top: 0,
        left: 0,
      },
      detailOpen: false,
      classMouse: ' ',
      cursor: 'none',
    };
  },
  components: {
    Timeline,
    Viewer,
    Channels,
    Details,
    Slugs,
    Loading,
  },
  computed: {
    ...mapGetters([
      'ready',
      'loading',
      'isPlaying',
      'isDetail',
      'currentSlug',
      'currentChannel',
      'currentSequence',
      'displayedSequence',
      'displayedName',
      'isChangeSequence',
    ]),
  },
  methods: {
    ...mapMutations([
      'play',
      'pause',
      'startLoading',
      'stopLoading',
      'updateChannel',
      'setCurrentChannel',
      'setDisplayedSequence',
    ]),
    ...mapActions([
      'getChannelById',
      'loadChannel',
      'playNextSequence',
      'playPreviousSequence',
      'updateSlug',
    ]),
    goSlug() {
      this.updateSlug('');
      this.$router.push('/c/a-la-une');
    },
    loadChannelById(id) {
      this.pause();
      this.startLoading();
      return Promise.all([
        this.getChannelById(id).then(channel => this.loadChannel(channel)),
      ])
        .then((results) => {
          this.stopLoading();
          this.updateChannel(results[0]);
          this.setCurrentChannel(results[0]);
        })
        // eslint-disable-next-line
        .catch(e => console.warn(e))
        .finally(() => this.play());
    },
    move(event) {
      let x = event.clientX - 15;
      let y = event.clientY - 15;
      const target = event.target;
      this.cursorStyle = 'none';

      if (target.className === 'scene' && this.isPlaying) {
        this.detailOpen = false;
        this.positionMouse.backgroundImage = `url(${srcImgMore})`;
        this.classMouse = 'more';
      }

      if (target.closest('.m-details') !== null || this.detailOpen === true) {
        this.detailOpen = true;
        if (target.classList.contains('scene') === true) { // close content
          this.positionMouse.backgroundImage = `url(${srcImgClose})`;
          this.classMouse = 'close';
        } else { // default content
          this.classMouse = 'default';
        }
        if (target.closest('.m-details__wrapper') !== null && target.className !== 'scene') {
          this.classMouse = 'default';
        }
      }
      if (target.closest('.o-player__slugs')) {
        this.classMouse = 'default';
      }
      if (target.closest('.m-timeline__wrapper')) {
        this.classMouse = 'default';
      }
      if (target.className === 'o-player__logo') {
        this.classMouse = 'default';
      }
      x = `${x}px`;
      y = `${y}px`;
      this.positionMouse.top = y;
      this.positionMouse.left = x;
    },
    scrollNext() {
      if (this.currentSequence === this.displayedSequence) {
        this.playNextSequence();
      } else {
        this.changer.seek(this.changer.totalDuration() - (this.currentSequence.duration / 1000));
      }
    },
    scrollPrevious() {
      if (this.currentSequence !== this.displayedSequence) {
        this.playPreviousSequence();
      }
      this.playPreviousSequence();
    },
  },
  watch: {
    isPlaying(isPlaying) {
      this.changer[isPlaying ? 'play' : 'pause']();
    },
    currentSequence(newCurrentSequence) {
      let duration = newCurrentSequence.duration / 1000;

      if (this.changer.totalDuration() - this.changer.time() > OFFSET) {
        this.changer.pause(0);
        this.changer.clear();
        this.changer.restart();
        duration += OFFSET;
      }

      this.changer.to({}, duration + OFFSET, {
        paused: !this.isPlaying,
      }, this.isPlaying ? `-=${OFFSET}` : 0)
        .call(() => {
          this.setDisplayedSequence(newCurrentSequence);
          this.active = true;
        }, [], this, `-=${duration}`)
        .call(() => this.playNextSequence(), [], this, `-=${OFFSET}`);
    },
    loading(isLoading) {
      setTimeout(() => {
        this.displayedLoading = isLoading ? this.displayedName : '';
      }, isLoading ? 0 : 2400);

      if (isLoading) {
        this.active = false;
      }
    },
    ready(isReady) {
      if (isReady) this.loadChannelById(this.$route.params.channelId || this.currentChannel.id);
    },
    $route(to) {
      this.loadChannelById(to.params.channelId || this.currentChannel.id);
    },
    isDetail(isDetail) {
      if (isDetail) {
        this.pause();
      } else if (!this.loading) {
        this.scrollNext();
        this.play();
      }
    },
  },
  created() {
    window.addEventListener('mousemove', this.move);
  },
  mounted() {
    document.addEventListener('keypress', (e) => {
      if (e.keyCode === 32 && !this.isChangeSequence) {
        this.scrollNext();
      }
    });

    window.addEventListener('wheel', (e) => {
      if (!e.ctrlKey && !this.isChangeSequence) {
        e.preventDefault();

        if (e.deltaY > 10) {
          this.scrollNext();
        } else if (e.deltaY < -10) {
          this.scrollPrevious();
        }
      }
    }, { passive: false });
  },
  destroyed() {
    window.removeEventListener('mousemove', this.move);
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  $channelsHeight: 0;
  $channelsWidth: 80px;
  $timelineRight: 50px;

  .o-player {
    position: relative;
    height: 100%;
    width: 100vw;
    overflow: hidden;

    &__logo {
      position: absolute;
      top: $timelineRight;
      left: $timelineRight;
      width: 65px;
    }
    &__viewer {
      height: 100%;
    }
    &__timeline {
      position: absolute;
      top: 0;
      bottom: $channelsHeight;
      right: -$channelsWidth * 2;
      transition: right 0.8s;
      width: 80px;
      overflow: hidden;
      text-align: right;

      &.--play {
        width: auto;
        right: $timelineRight;
        overflow: visible;
        transition: right 0.8s;
      }
    }
    &__channels {
      position: absolute;
      right: -$channelsWidth;
      bottom: $timelineRight;
      transition: right 1s;

      max-height: $channelsHeight;
      width: $channelsWidth;

      &.--play {
        right: $timelineRight;
        transition: right 1s;
      }

    }
    &__slugs {
      position: absolute;
      left: $timelineRight;
      bottom: -($timelineRight + 84px);
      transition: bottom 0.8s;

      &.--play {
        bottom: $timelineRight;
        transition: bottom 0.8s;
      }
    }
    &__loading {
      position: fixed;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      z-index: 10;

      opacity: 0.99;

      color: black;

      pointer-events: none;
      user-select: none;

      &.--hide {
        display: none;
      }
    }
    &__mouse {
      position: fixed;
      z-index: 200;
      display: block;
      width: 40px;
      height: 40px;
      pointer-events: none;
      background-repeat: no-repeat;
      background-position: center;
      background-size: 50%;
      cursor: none;
      &.more {
        background-color: #fff;

        span.more {
          opacity: 1;
          width: 120px;
        }
      }
      &.close {
        background-color: #fff;

        span.close {
          opacity: 1;
          width: 85px;
        }
      }
      &.default {
        display: none;
      }
      span {
        background-color: #fff;
        position: absolute;
        left: 42px;
        top: 0;
        font-size: 14px;
        font-family: TrioGrotesk, sans-serif;
        text-transform: uppercase;
        height: 40px;
        line-height: 40px;
        padding: 0px 17px;
        opacity: 0;
        transition: .5s ease-out opacity;
        min-width: 50px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Player.vue